<template>
  <div class="flex h-full w-full">
    <div class="bg-gray-100 flex-1 overflow-y-auto overflow-x-hidden">
      <div v-if="rules.length > 0" class="mx-20 mt-5 bg-white mb-2">
        <div class="p-3">
          <el-button type="primary" icon="el-icon-plus" @click="onAdd">添加规则</el-button>
        </div>
        <div v-for="(item, index) in rules" :key="index">
          <div class="h-0 border-t mx-[15px]" />
          <div class="flex flex-row">
            <div class=" p-5 grow">
              <template v-for="(cond, sub_index) in item.filter.cond">
                <div :key="sub_index" class="my-1">
                  <div class="text-gray-400">
                    {{ sub_index ===0 ? '当' : (item.filter.rel === 'and' ? '且' : '或') }}
                    <span class="text-black"><span class="text-gray-400">「</span>{{ getWidgetName(cond.field) }}<span class="text-gray-400">」</span></span>
                    {{ getMethodName(cond.method) }}
                    {{ cond.value[0] }}
                    <template v-if="sub_index === item.filter.cond.length - 1">
                      时
                    </template>
                  </div>
                </div>
              </template>

              <div class="text-gray-400">
                显示
                <template v-for="field in item.fields">
                  <span :key="field" class="text-black"><span class="text-gray-400">「</span>{{ getWidgetName(field) }}<span class="text-gray-400">」</span></span>
                </template>
              </div>
            </div>
            <div class="w-[130px] py-5 pr-5">
              <div class="btn-container">
                <el-button type="text" class="pr-[15px]" @click="onEdit(item)">编辑</el-button>
                <el-button type="text" class="pl-[15px] !text-red-400" @click="onRuleDelete(index)">删除</el-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <el-empty v-else description="让字段在特定条件成立时显示，反之隐藏。">
        <el-button type="primary" @click="onAdd">添加规则</el-button>
      </el-empty>
    </div>
    <el-dialog
      v-if="addRuleVisible"
      append-to-body
      class="pub_dialog" width="60%" title="字段显隐规则" :visible.sync="addRuleVisible"
      :close-on-click-modal="false"
    >
      <div class="flex flex-col h-full">
        <div class="grow px-5 pt-5 overflow-y-auto leading-8">
          <div>
            满足以下
            <span class="combo">
              <el-dropdown trigger="click" @command="handleRelCommand">
                <span class="el-dropdown-link">
                  {{ getRelName(rule.filter.rel) }}<i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item v-for="rel in rels" :key="rel.value" :command="rel.value">{{
                    rel.name
                  }}</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </span>

            条件时
          </div>
          <div v-for="(cond, index) in rule.filter.cond" :key="index" class="flex leading-8 py-1">
            <div class="flex grow justify-between flex-row">
              <div class="w-1/2 justify-between flex">
                <div class="border w-1/2 h-8 rounded flex items-center overflow-x-auto leading-8 truncate" :title="getWidgetName(cond.field)">
                  <i class="bi bi-person-workspace mx-[10px]" />{{ getWidgetName(cond.field) }}
                </div>
                <div class="mx-2 w-1/2 m-auto flex justify-center method">
                  <el-dropdown trigger="click" @command="cond.method=$event">
                    <span class="el-dropdown-link">
                      {{ getMethodName(cond.method) }}<i class="el-icon-arrow-down el-icon--right" />
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        v-for="method in methods"
                        :key="method.value" :command="method.value"
                      >
                        {{ method.name }}
                      </el-dropdown-item>
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
              <div class="w-1/2">
                <div class="fui_dept_check">
                  <el-select
                    v-if="getWidgetType(cond.field) === 'dept'" style="width: 100%;" size="mini"
                    value="cond.value" placeholder="请选择"
                  >
                    <el-option v-for="field in fields" :key="field.value" :label="field.name" :value="field.value" />
                  </el-select>
                  <el-input v-else v-model="cond.value[0]" style="width: 100%;" size="mini" />
                </div>
              </div>
            </div>

            <i class="bi bi-trash w-4 px-2 cursor-pointer" @click="onDelete(index)" />
          </div>
          <div>
            <el-popover
              v-model="menuVisible"
              placement="bottom-start"
              width="200"
              :append-to-body="false"
              popper-class="popper-class"
            >
              <div>
                <el-menu v-if="menuVisible" @select="handleSelect">
                  <el-menu-item
                    v-for="widget in widgetList" :key="widget.key" :index="widget.key"
                    style="height: 32px;line-height: 32px;"
                  >
                    {{ widget.name }}
                  </el-menu-item>
                </el-menu>
              </div>
              <span slot="reference" class="cursor-pointer text-sky-500 text-sm h-9 leading-9">
                <i class="bi bi-plus text-base" />
                添加条件
              </span>
            </el-popover>
          </div>
          <div class="x-label visible_field_label pt-10 pb-2" style="width: 100%;">
            <a>显示以下字段</a>
          </div>
          <div
            class="w-full mb-5"
            style="height: 32px; line-height: 30px;"
          >
            <el-select v-model="rule.fields" multiple style="width: 100%;">
              <el-option v-for="widget in widgets" :key="widget.key" :value="widget.key" :label="widget.name" />
            </el-select>
          </div>
        </div>
        <div class="h-15 border-t py-[14px] px-5 text-right">
          <el-button type="primary" @click="onConfirm">确定</el-button>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>

import _ from 'lodash'
import {getAllWidgets} from '../utils'

export default {
  name: 'FieldRule',
  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
    data: {
      type: Object,
      default: () => {
      },
    },
    widgets: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      widgetName: {},
      editIndex: -1,
      menuVisible: false,
      rules: this.value,
      rule: {
        fields: [],
        filter: {rel: 'and', cond: []},
      },
      rels: [{name: '所有', value: 'and'}, {name: '任一', value: 'or'}],
      methods: [
        {name: '等于', value: 'eq', type: ['input', 'date']},
        {name: '不等于', value: 'neq', type: ['input']},
        // {name: '大于等于', value: 'gte', type: ['date']},
        // {name: '小于等于', value: 'lte', type: ['date']},
        // {name: '选择范围', value: 'range', type: ['date']},
        // {name: '动态筛选', value: 'formula', type: ['date']},
        // {name: '等于任意一个', value: 'in', type: ['input']},
        // {name: '不等于任意一个', value: 'nin', type: ['input']},
        {name: '为空', value: 'empty', type: ['input']},
        {name: '不为空', value: 'not_empty', type: ['input']},
      ],
      text: '',
      addRuleVisible: false,
      widgetList: [],
    }
  },
  computed: {
    relyFields() {
      if (this.rely.data.formId === '') {
        return []
      }
      return this.form.find(item => item.id === this.rely.data.formId).fields
    },
  },
  created() {
    console.log('FieldRule created', this.value, this.widgets)
    this.widgetList = getAllWidgets(this.widgets)
  },
  methods: {
    onRuleDelete(index) {
      this.rules.splice(index, 1)
      this.$emit('input', this.rules)
    },
    onAdd() {
      this.editIndex = -1
      this.addRuleVisible = true
      this.rule = {
        fields: [],
        filter: {rel: 'and', cond: []},
      }
    },
    onEdit(item) {
      this.editIndex = this.rules.indexOf(item)
      this.rule = _.cloneDeep(item)
      this.addRuleVisible = true
    },
    onConfirm() {
      this.addRuleVisible = false
      if (this.editIndex === -1) {
        this.rules.push(this.rule)
      } else {
        this.rules.splice(this.editIndex, 1, this.rule)
      }
      this.$emit('input', this.rules)
    },
    onDelete(index) {
      this.rule.filter.cond.splice(index, 1)
    },
    getWidgetType(key) {
      return this.widgetList.find(item => item.key === key).type
    },
    getWidgetName(key) {
      return this.widgetList.find(item => item.key === key).name

    },
    getRelName(val) {
      return this.rels.find(item => item.value === val).name
    },
    getMethodName(val) {
      return this.methods.find(item => item.value === val).name
    },
    handleRelCommand(command) {
      this.rule.filter.rel = command
    },
    handleSelect(key, keyPath) {
      console.log(key, keyPath, this.data, this.widgets)
      this.rule.filter.cond.push({
        field: key,
        method: 'eq',
        value: [],
      })
      this.menuVisible = false
    },
  },
}
</script>

<style lang="scss" scoped>

.combo, .method {
  .el-dropdown-link {
    cursor: pointer;
    color: #409EFF;
  }
}

.el-menu {
  border-right: 0;
}
::v-deep .popper-class {
  .el-menu {
    max-height: 300px;
    overflow: auto;
  }
}
</style>
